// Convert an OKLCH color to a #rrggbb sRGB hex string (gamut-clamped).
// Based on Björn Ottosson's OKLab → linear-sRGB matrices.
//
// Used to theme canvas effects (e.g. the footer LetterGlitch) to the same
// random hue as the CSS `--primary`, since those effects interpolate via
// hex → rgb and can't consume oklch() strings directly.
export function oklchToHex(l: number, c: number, hueDeg: number): string {
  const h = (hueDeg * Math.PI) / 180;
  const a = c * Math.cos(h);
  const b = c * Math.sin(h);

  const l_ = l + 0.3963377774 * a + 0.2158037573 * b;
  const m_ = l - 0.1055613458 * a - 0.0638541728 * b;
  const s_ = l - 0.0894841775 * a - 1.291485548 * b;

  const lc = l_ * l_ * l_;
  const mc = m_ * m_ * m_;
  const sc = s_ * s_ * s_;

  const rLin = 4.0767416621 * lc - 3.3077115913 * mc + 0.2309699292 * sc;
  const gLin = -1.2684380046 * lc + 2.6097574011 * mc - 0.3413193965 * sc;
  const bLin = -0.0041960863 * lc - 0.7034186147 * mc + 1.707614701 * sc;

  const toGamma = (x: number) => {
    const v =
      x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055;
    return Math.max(0, Math.min(1, v));
  };

  const toHex = (x: number) =>
    Math.round(toGamma(x) * 255)
      .toString(16)
      .padStart(2, "0");

  return `#${toHex(rLin)}${toHex(gLin)}${toHex(bLin)}`;
}
